import { Injectable } from '@angular/core';

@Injectable()
export class DateFunctionsProvider {

  constructor() {

  }

  public toLongDateString(dateString: string) {

    let dateStringArray = dateString.split(", ");
    let date = dateStringArray[0];
    let time = dateStringArray[1];

    let dateArray = date.split("/");
    let year = dateArray[2];
    let month = dateArray[1];
    let day = dateArray[0];

    let timeArray = time.split(":");
    let hour = timeArray[0];
    let minute = timeArray[1];

    return year + "-" + month + "-" + day + ", " + hour + ":" + minute;

  }

  public toLongDateStringFromApi(dateString: string) {

    let dateStringArray = dateString.split("T");
    let date = dateStringArray[0];
    let time = dateStringArray[1];

    let dateArray = date.split("-");
    let year = dateArray[0];
    let month = dateArray[1];
    let day = dateArray[2];

    let timeArray = time.split(":");
    let hour = timeArray[0];
    let minute = timeArray[1];

    return year + "-" + month + "-" + day + ", " + hour + ":" + minute;

  }

}



// WEBPACK FOOTER //
// ./src/providers/date-functions/date-functions.ts